/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetUpgradeStatusResponse } from '../models/get-upgrade-status-response';
import { UpgradeRequest } from '../models/upgrade-request';
import { UpgradeRequestV2 } from '../models/upgrade-request-v-2';
import { UpgradeResponse } from '../models/upgrade-response';

@Injectable({
  providedIn: 'root',
})
export class UpgradeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getUpgradeStatus
   */
  static readonly GetUpgradeStatusPath = '/upgrades/{recLoc}/{upgradeId}/status';

  /**
   * Returns a status for upgrade process.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUpgradeStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpgradeStatus$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * Unique ID of the upgrade process that was initiated
     */
    upgradeId: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GetUpgradeStatusResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.GetUpgradeStatusPath, 'get');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.path('upgradeId', params.upgradeId, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetUpgradeStatusResponse>;
      })
    );
  }

  /**
   * Returns a status for upgrade process.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUpgradeStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpgradeStatus(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * Unique ID of the upgrade process that was initiated
     */
    upgradeId: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
  },
  context?: HttpContext

): Observable<GetUpgradeStatusResponse> {

    return this.getUpgradeStatus$Response(params,context).pipe(
      map((r: StrictHttpResponse<GetUpgradeStatusResponse>) => r.body as GetUpgradeStatusResponse)
    );
  }

  /**
   * Path part for operation getUpgradeStatusV2
   */
  static readonly GetUpgradeStatusV2Path = '/v2/upgrades/{recLoc}/{upgradeId}/status';

  /**
   * Returns a status for upgrade process.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUpgradeStatusV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpgradeStatusV2$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * Unique ID of the upgrade process that was initiated
     */
    upgradeId: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<GetUpgradeStatusResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.GetUpgradeStatusV2Path, 'get');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.path('upgradeId', params.upgradeId, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetUpgradeStatusResponse>;
      })
    );
  }

  /**
   * Returns a status for upgrade process.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUpgradeStatusV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUpgradeStatusV2(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * Unique ID of the upgrade process that was initiated
     */
    upgradeId: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
  },
  context?: HttpContext

): Observable<GetUpgradeStatusResponse> {

    return this.getUpgradeStatusV2$Response(params,context).pipe(
      map((r: StrictHttpResponse<GetUpgradeStatusResponse>) => r.body as GetUpgradeStatusResponse)
    );
  }

  /**
   * Path part for operation upgrade
   */
  static readonly UpgradePath = '/upgrades/{recLoc}';

  /**
   * Start upgrade process as non-logged-in customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upgrade()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgrade$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UpgradeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.UpgradePath, 'post');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.query('lastName', params.lastName, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

      rb.body(params.body, 'application/json');
    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpgradeResponse>;
      })
    );
  }

  /**
   * Start upgrade process as non-logged-in customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upgrade$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgrade(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequest
  },
  context?: HttpContext

): Observable<UpgradeResponse> {

    return this.upgrade$Response(params,context).pipe(
      map((r: StrictHttpResponse<UpgradeResponse>) => r.body as UpgradeResponse)
    );
  }

  /**
   * Path part for operation upgradeV2
   */
  static readonly UpgradeV2Path = '/v2/upgrades/{recLoc}';

  /**
   * Start upgrade process as non-logged-in customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upgradeV2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeV2$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequestV2
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UpgradeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.UpgradeV2Path, 'post');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.query('lastName', params.lastName, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

      rb.body(params.body, 'application/json');
    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpgradeResponse>;
      })
    );
  }

  /**
   * Start upgrade process as non-logged-in customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upgradeV2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeV2(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequestV2
  },
  context?: HttpContext

): Observable<UpgradeResponse> {

    return this.upgradeV2$Response(params,context).pipe(
      map((r: StrictHttpResponse<UpgradeResponse>) => r.body as UpgradeResponse)
    );
  }

  /**
   * Path part for operation upgradeAuthenticated
   */
  static readonly UpgradeAuthenticatedPath = '/members/upgrades/{recLoc}';

  /**
   * Start upgrade process as logged-in customer. Allows also payments with points and vouchers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upgradeAuthenticated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeAuthenticated$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UpgradeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.UpgradeAuthenticatedPath, 'post');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.query('lastName', params.lastName, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

      rb.body(params.body, 'application/json');
    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }
    if(this.config.bearerAuth){
      rb.header('Authorization', this.config.bearerAuth);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpgradeResponse>;
      })
    );
  }

  /**
   * Start upgrade process as logged-in customer. Allows also payments with points and vouchers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upgradeAuthenticated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeAuthenticated(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequest
  },
  context?: HttpContext

): Observable<UpgradeResponse> {

    return this.upgradeAuthenticated$Response(params,context).pipe(
      map((r: StrictHttpResponse<UpgradeResponse>) => r.body as UpgradeResponse)
    );
  }

  /**
   * Path part for operation upgradeV2Authenticated
   */
  static readonly UpgradeV2AuthenticatedPath = '/v2/members/upgrades/{recLoc}';

  /**
   * Start upgrade process as logged-in customer. Allows also payments with points and vouchers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upgradeV2Authenticated()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeV2Authenticated$Response(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequestV2
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UpgradeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, UpgradeService.UpgradeV2AuthenticatedPath, 'post');
    if (params) {
      rb.path('recLoc', params.recLoc, {});
      rb.query('lastName', params.lastName, {});
      rb.header('X-Correlation-ID', params['X-Correlation-ID'], {});

      rb.body(params.body, 'application/json');
    }
    if(this.config.apiKey){
      rb.header('x-api-key', this.config.apiKey);
    }
    if(this.config.bearerAuth){
      rb.header('Authorization', this.config.bearerAuth);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpgradeResponse>;
      })
    );
  }

  /**
   * Start upgrade process as logged-in customer. Allows also payments with points and vouchers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upgradeV2Authenticated$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upgradeV2Authenticated(params: {

    /**
     * Booking record locator
     */
    recLoc: string;

    /**
     * One last name as it is in the booking specified by the record locator
     */
    lastName: string;

    /**
     * Unique tracking code to gather all information from logs regarding this request
     */
    'X-Correlation-ID'?: string;
    body: UpgradeRequestV2
  },
  context?: HttpContext

): Observable<UpgradeResponse> {

    return this.upgradeV2Authenticated$Response(params,context).pipe(
      map((r: StrictHttpResponse<UpgradeResponse>) => r.body as UpgradeResponse)
    );
  }

}
